function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M195.8,1c5.3,0,10.6,0,15.8,0c6.1,1.1,12.2,1.8,18.2,3.4c43.4,11,74.8,46.2,80.9,90.5c0.8,5.6,1,11.2,1.5,17.2 c15.1,0,29.9,0,44.9,0c8.8,98.3,17.6,196.2,26.4,294.3c-119.9,0-239.6,0-359.5,0c8.8-98.2,17.6-196.2,26.4-294.6 c15.2,0,30,0,44.6,0c1-8.6,1.1-16.9,3-24.7c10.6-43.4,37.4-71.3,80.7-82.9C184.3,2.7,190.1,2,195.8,1z M291.6,111.7 c-7.3-36.8-41.4-71.2-88.3-70.8c-48.5,0.3-80.9,36.7-87.3,70.8C174.5,111.7,232.9,111.7,291.6,111.7z M117.8,70 c41.4-59,131.3-58.7,171.8,0c-10.9-27.4-43.8-55.8-86.1-55.7C161.6,14.4,128.8,42.4,117.8,70z"
}));

var SvgShoppingBag = function SvgShoppingBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.5 407.5",
    style: {
      enableBackground: "new 0 0 407.5 407.5"
    },
    fill: "current",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-bag.a8ea0957.svg";
export { ForwardRef as ReactComponent };